import React from 'react'
import Popular from '../Components/Popular/Popular';
import Footer from '../Components/Footer/Footer';

export const Shop = () => {
  return (
    <div>
      <Popular/>
    </div>
  )
}
export default Shop;